import {useTranslation} from 'react-i18next';

import {SxProps} from '@mui/material';

import {EmpionButton} from '../EmpionButton/EmpionButton';

import {ReactComponent as LinkedInLogo} from '../../assets/social/linkedin/buttons/LinkedInLogo.svg';
import {greenColors} from '../../layouts/theme/designSystem';

interface Props {
  onClick: () => void;
  sx?: SxProps;
  fillColor?: string;
  text?: string | null;
  isDisabled?: boolean;
  hoverBackgroundColor?: string;
  hoverTextColor?: string;
}

export const LinkedInButton = ({
  onClick,
  sx,
  fillColor,
  text,
  isDisabled,
  hoverBackgroundColor,
  hoverTextColor
}: Props) => {
  const {t} = useTranslation();

  return (
    <EmpionButton
      variant='outlined'
      onClick={onClick}
      disabled={isDisabled}
      disabledColor='white'
      textColor={greenColors[700]}
      sx={{
        backgroundColor: isDisabled ? 'white' : 'transparent',
        border: `1px solid ${greenColors[700]}`,
        width: '100%',
        display: 'flex',
        color: greenColors[700],
        fontWeight: {xs: 400, sm: 500},
        fontSize: {xs: '18px', sm: '20px'},
        justifyContent: {xs: 'center', sm: 'center'},
        alignSelf: {xs: 'end', sm: 'center'},
        padding: 0.6,
        '&:hover': {
          backgroundColor: isDisabled ? 'white' : hoverBackgroundColor,
          boxShadow: 'none',
          color: hoverTextColor,
        },
        ...sx,
      }}
    >
      <LinkedInLogo
        fill={fillColor || '#0073B1'}
        style={{
          left: 6,
          backgroundColor: 'white',
          marginRight: '8px',
        }}
        aria-label='LinkedIn logo'
      />
      {text || t('shared.socialSignin.linkedin')}
    </EmpionButton>
  );
};
